export default __webpack_public_path__ + "static/media/icons8-pass-fail-100.a2135cc0.svg";